var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoPartner24X24 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_partner24x24",
    transform: "translate(-2.004 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "business-cards",
    transform: "translate(2.004 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25392",
    "data-name": "Group 25392"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46273",
    "data-name": "Path 46273",
    d: "M32.611,63.409a2.1,2.1,0,0,1,2.1-2.1H44.18L41.281,57a1.267,1.267,0,0,0-1.757-.342l-8.918,6a1.267,1.267,0,0,0-.342,1.757l2.356,3.5V63.409Z",
    transform: "translate(-30.049 -56.445)",
    fill: "#999"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_46274",
    "data-name": "Path 46274",
    d: "M121.981,220.191a1.38,1.38,0,0,0,1.38,1.38h11.962a1.38,1.38,0,0,0,1.38-1.38V212.58a1.38,1.38,0,0,0-1.38-1.38H123.367a1.38,1.38,0,0,0-1.38,1.38v7.61Zm12.919-1.517h-4.969a.338.338,0,1,1,0-.669H134.9a.338.338,0,1,1,0,.669Zm.081-1.853h-4.149a.347.347,0,0,1,0-.693h4.149a.347.347,0,1,1,0,.693Zm-5.536-2.441h5.536a.347.347,0,0,1,0,.693h-5.536a.347.347,0,0,1,0-.693Zm-3.662-.339a2.348,2.348,0,1,1-2.348,2.348,2.348,2.348,0,0,1,2.348-2.348Z",
    transform: "translate(-118.704 -205.571)",
    fill: "#999"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoPartner24X24);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_partner24x24.1b6fdb84316dc1da85c3fd4b34a68c09.svg";